import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/manage/auctions/$auctionId/registrations/$registrationId")({
    component: Outlet,
    loader: async ({ context, params }) => {
        await context.queryClient.ensureQueryData(
            context.qof.registration.get(params.auctionId, params.registrationId),
        );
    },
});
